export default {
	title: "Web3",
	rule: "Popis pravidla",
	safe: "Bezpečnost fondov",
	balance: {
		total: "Celková suma",
		yesterday: "Včerajšie výnosy",
		cumulatively: "Kumulatívne výnosy",
		in: "Vklad",
		out: "Výber",
		available: "Dostupný zostatok"
	},
	actions: {
		in: "Vložiť",
		out: "Vybrat"
	},
	type: ["Všetko", "Vklad", "Výber", "Výnosy"],
	TransactionPassword: "Transakčný heslo",
	Amount: "Cantidad",
	date: "Fecha"
};
